import {
  STUDIO_AI_SUBSCRIPTION_STATUS_COOKIE_NAME,
  SUBSCRIPTION_STATUS_COOKIE_NAME,
} from 'constants/cookies'
import { useCookieValue } from 'hooks/use-cookie-value'
import { useIsLoggedInQuery } from 'auth/hooks'

export function useCookieState() {
  const { data: isLoggedIn } = useIsLoggedInQuery()
  const [aiStatus] = useCookieValue(
    isLoggedIn !== false ? STUDIO_AI_SUBSCRIPTION_STATUS_COOKIE_NAME : undefined,
  )
  const [allAccessStatus] = useCookieValue(
    isLoggedIn !== false ? SUBSCRIPTION_STATUS_COOKIE_NAME : undefined,
  )

  return { aiStatus, allAccessStatus }
}
